'use strict';

require('../modules/forms/forms');

angular.module('far.forms.educationGalleryForm', ['dekky.forms'])
    .service('educationGalleryForm', function(form, fileUploadFilters) {
        var eventGalleryForm = form('educationGallery');

        eventGalleryForm
            .addField('slides_files', 'imageUpload', {
                validators: { required: true },
                label: 'Загрузить изображение',
                fieldData: {
                    multipleUpload: 'true'
                },
                uploader: {
                    url: Routing.generate('api_upload_post_image'),
                    filters: [
                        fileUploadFilters.fileSize()
                    ],
                    autoUpload: true,
                    removeAfterUpload: true
                }
            });

        return eventGalleryForm;
    });
